export enum ClientDeclineReason {
  BetterCandidateFound = 1,
  OutOfBudget = 2,
  SkillsMismatch = 3,
  InsufficientExperience = 4,
  LackOfProjectUnderstanding = 5,
  NoConcreteSamples = 6,
  UnsatisfactoryCastingAnswers = 7,
  Other = 8
}
